module.exports = __webpack_public_path__ + "assets/img/ozmo-twitter.e22d7c8b.png";